import { CheckCircle2, Clock, Hourglass, XCircle, Moon, CircleDashed, LogOut } from "lucide-react";

export const STATUS_META = {
  active: { label: "Active", icon: null, cls: "bg-[#2E7D32]" },
  unprocessed: { label: "Unprocessed", Icon: CircleDashed, color: "text-[#7B6157]" },
  pending: { label: "Pending (Pre-Admit)", Icon: Clock, color: "text-[#E6A700]" },
  referred: { label: "Pending (Pre-Admit)", Icon: Clock, color: "text-[#E6A700]" },
  waitlist: { label: "Waitlist", Icon: Hourglass, color: "text-[#1565C0]" },
  denied: { label: "Denied", Icon: XCircle, color: "text-[#C62828]" },
  inactive: { label: "Inactive/Alumni", Icon: Moon, color: "text-[#546E7A]" },
  alumni: { label: "Inactive/Alumni", Icon: Moon, color: "text-[#546E7A]" },
  discharged: { label: "Discharged", Icon: LogOut, color: "text-[#6D4C41]" },
  completed: { label: "Completed", Icon: CheckCircle2, color: "text-[#2E7D32]" },
};

export function StatusDot({ status, className = "" }) {
  const meta = STATUS_META[(status || "active").toLowerCase()] || STATUS_META.active;
  if (!meta.Icon) {
    return (
      <span data-testid={`status-dot-${status || "active"}`} title="Active" className={`relative inline-flex h-2.5 w-2.5 shrink-0 ${className}`}>
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#4CAF50] opacity-60 animate-ping" />
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${meta.cls} ring-2 ring-white`} />
      </span>
    );
  }
  const Icon = meta.Icon;
  return <Icon data-testid={`status-icon-${status}`} size={13} title={meta.label} className={`shrink-0 ${meta.color} ${className}`} />;
}

export function AvatarWithStatus({ children, status }) {
  return (
    <span className="relative inline-flex shrink-0">
      {children}
      <span className="absolute -bottom-0.5 -right-0.5 flex items-center justify-center rounded-full bg-white p-[1px]">
        <StatusDot status={status} />
      </span>
    </span>
  );
}
